<template>
  <div
    class="insights-widget-confidence-badge"
    :style="confidenceStyle"
  >
    {{ confidenceBadge.name }}
    <i
      v-tooltip="{ placement: 'right' }"
      title="Unusual activity classification becomes higher as work metrics deviate further from the average. This classification helps managers prioritize investigations and is not a confirmation of cheating."
      class="hi hi-12 hi-info-filled block"
    ></i>
  </div>
</template>

<script>
import { INSIGHTS_CONFIDENCE_LEVELS } from '~/app_constants';

export default {
  name: 'InsightsUnusualActivityWidgetConfidenceBadge',
  props: {
    confidenceLevel: {
      type: [Number, String],
      required: true,
    },
  },
  computed: {
    confidenceBadge() {
      return INSIGHTS_CONFIDENCE_LEVELS[parseInt(this.confidenceLevel, 10)];
    },
    confidenceStyle() {
      return {
        color: this.confidenceBadge.color,
        backgroundColor: this.confidenceBadge.lightColor,
        borderColor: this.confidenceBadge.color,
      };
    },
  },
};
</script>
